/* V10.51: naechstpassende Variante zu einer Auswahl (fuer die Kaufleiste unten, assets/sticky-atc.js).
   vals = Optionswert-IDs je Position, pos = zuletzt geaenderte Position (0-basiert). Liefert die ID-Liste der Variante oder null. */
window.__lxResolve = function (vals, pos) {
  var sc = document.querySelector('script[data-lx-sp-data]');
  if (!sc) return null;
  var D;
  try { D = JSON.parse(sc.textContent); } catch (e) { return null; }
  var best = null, bs = -1;
  Object.keys(D.v).forEach(function (k) {
    var ov = D.v[k].ov || [];
    if (String(ov[pos]) !== String(vals[pos])) return;
    var sc2 = 0;
    for (var j = 0; j < ov.length; j++) {
      if (j === pos) continue;
      if (String(ov[j]) === String(vals[j])) sc2 += j === 0 ? 100 : (j === 1 ? 10 : 1);
    }
    if (sc2 > bs) { bs = sc2; best = ov.map(String); }
  });
  return best;
};
(function () {
  if (window.__lxSetPicker) { window.__lxSetPicker(); return; }
  function data(root) {
    var s = root.querySelector('script[data-lx-sp-data]');
    if (!s) return null;
    if (!root.__lxD) { try { root.__lxD = JSON.parse(s.textContent); } catch (e) { return null; } }
    return root.__lxD;
  }
  function val(root, name) {
    var c = root.querySelector('input.lx-sp__in[name^="' + name + '"]:checked');
    return c ? c.value : null;
  }
  function ids(D) { return Object.keys(D.v); }
  function find(D, d, u, s, xv) {
    var all = ids(D), i, x;
    for (i = 0; i < all.length; i++) { x = D.v[all[i]]; if (x.d === d && x.u === u && (s === null || x.s === s) && (xv === null || x.x === xv)) return all[i]; }
    for (i = 0; i < all.length; i++) { x = D.v[all[i]]; if (x.d === d && x.u === u && (s === null || x.s === s)) return all[i]; }
    for (i = 0; i < all.length; i++) { x = D.v[all[i]]; if (x.d === d && x.u === u) return all[i]; }
    for (i = 0; i < all.length; i++) { x = D.v[all[i]]; if (x.d === d && (s === null || x.s === s)) return all[i]; }
    for (i = 0; i < all.length; i++) { if (D.v[all[i]].d === d) return all[i]; }
    return null;
  }
  function paint(root, D, id) {
    var x = D.v[id];
    if (!x) return;
    var hasK2 = false, hasEn = false;
    ids(D).forEach(function (k) { var y = D.v[k]; if (y.d === x.d) { if (y.u === 'enerack') hasEn = true; else hasK2 = true; } });
    root.querySelectorAll('input[name^="lxsp-dach-"]').forEach(function (i) { i.checked = i.value === x.d; });
    root.querySelectorAll('input[name^="lxsp-uk-"]').forEach(function (i) {
      i.disabled = i.value === 'enerack' ? !hasEn : !hasK2;
      i.checked = i.value === x.u;
    });
    var en = root.querySelector('[data-lx-sp-ennote]');
    if (en) en.textContent = hasEn ? '' : 'Für diese Dachart nur K2 Systems';
    var k2 = root.querySelector('[data-lx-sp-k2note]');
    if (k2) k2.textContent = hasK2 ? '' : 'Für diese Dachart nur Enerack';
    root.querySelectorAll('input[name^="lxsp-sp-"]').forEach(function (i) {
      var ok = ids(D).some(function (k) { var y = D.v[k]; return y.d === x.d && y.u === x.u && y.s === i.value; });
      i.disabled = !ok;
      i.checked = i.value === x.s;
    });
    var xc = 0;
    root.querySelectorAll('input[name^="lxsp-x-"]').forEach(function (i) {
      var ok = ids(D).some(function (k) { var y = D.v[k]; return y.d === x.d && y.u === x.u && y.s === x.s && y.x === i.value; });
      i.disabled = !ok;
      i.checked = i.value === x.x;
      if (ok) xc++;
    });
    var xs = root.querySelector('[data-lx-sp-xstep]');
    if (xs) xs.hidden = xc < 2;
    var t = root.querySelector('[data-lx-sp-title]');
    if (t) t.textContent = x.d + ' · ' + (x.u === 'enerack' ? 'Enerack' : 'K2 Systems') + (x.s ? ' · ' + x.s : '') + (x.x && xc > 1 ? ' · ' + x.x : '');
    root.setAttribute('data-current', id);
  }
  function themePicker(root) {
    var sec = root.closest('[id^="shopify-section-"]');
    return (sec && sec.querySelector('variant-picker[data-main-product="true"]')) || document.querySelector('variant-picker[data-main-product="true"]');
  }
  function go(root, D, id) {
    var x = D.v[id];
    var url = root.getAttribute('data-url') + '?variant=' + id;
    paint(root, D, id);
    var pk = themePicker(root);
    if (!pk || typeof pk.__renderProductInfo !== 'function') { location.href = url; return; }
    try {
      pk.optionsSelectedValues = x.ov.slice();
      pk.querySelectorAll('.variant-option').forEach(function (o) {
        var on = String(o.dataset.optionValueId) === String(x.ov[Number(o.dataset.optionPosition) - 1]);
        o.classList.toggle('selected', on);
        if (o.tagName === 'INPUT') o.checked = on;
      });
      root.classList.add('is-loading');
      history.replaceState({}, '', url);
      if (window.__lxSetSync) window.__lxSetSync();
      Promise.resolve(pk.__renderProductInfo()).then(function () {
        root.classList.remove('is-loading');
        if (window.__lxSetSync) window.__lxSetSync();
      }, function () { location.href = url; });
    } catch (e) {
      location.href = url;
    }
  }
  function onChange(e) {
    var inp = e.target;
    if (!inp || !inp.classList || !inp.classList.contains('lx-sp__in')) return;
    e.stopPropagation();
    var root = inp.closest('[data-lx-sp]');
    var D = root && data(root);
    if (!D) return;
    var d = val(root, 'lxsp-dach-'), u = val(root, 'lxsp-uk-'), s = val(root, 'lxsp-sp-'), xv = val(root, 'lxsp-x-');
    if (inp.name.indexOf('lxsp-dach-') === 0 && !ids(D).some(function (k) { var y = D.v[k]; return y.d === d && y.u === u; })) u = 'k2';
    var id = find(D, d, u, s, xv);
    if (id && id !== root.getAttribute('data-current')) go(root, D, id);
  }
  function sync() {
    document.querySelectorAll('[data-lx-sp]').forEach(function (root) {
      var D = data(root);
      if (!D || root.classList.contains('is-loading')) return;
      if (!root.getAttribute('data-current')) {
        var c = find(D, val(root, 'lxsp-dach-'), val(root, 'lxsp-uk-'), val(root, 'lxsp-sp-'), val(root, 'lxsp-x-'));
        if (c) root.setAttribute('data-current', c);
      }
      var m = location.search.match(/[?&]variant=(\d+)/);
      var id = m ? m[1] : null;
      if (!id) { var pk = themePicker(root); if (pk && pk.dataset.currentVariantId) id = pk.dataset.currentVariantId; }
      if (id && D.v[id] && id !== root.getAttribute('data-current')) paint(root, D, id);
    });
  }
  window.__lxSetPicker = sync;
  document.addEventListener('change', onChange, true);
  setInterval(sync, 700);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
